export const HARLEY_DAVIDSON_NAME = 'Harley Davidson'
export const SGWS_NAME = 'Southern Glazers Wine and Spirits'
